module.exports = __webpack_public_path__ + "img/9.b63f8ea6.png";